import { render, staticRenderFns } from "./MemberMessage.vue?vue&type=template&id=3f824c9a&scoped=true&"
import script from "./MemberMessage.vue?vue&type=script&lang=js&"
export * from "./MemberMessage.vue?vue&type=script&lang=js&"
import style0 from "./MemberMessage.vue?vue&type=style&index=0&id=3f824c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f824c9a",
  null
  
)

export default component.exports